export const selectCategories = (state)=> state.categories.categories;

export const selectTitle = (state)=>state.categories.categoriesTitle;